if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        if (!this.classList.contains('amk-media-viewer')) return;
        this.content = this.querySelector('.product-media-modal__content');
        this.previous = this.querySelector('[data-amk-previous]');
        this.next = this.querySelector('[data-amk-next]');
        this.previous.addEventListener('click', () => this.move(-1));
        this.next.addEventListener('click', () => this.move(1));
        this.content.addEventListener('dragstart', (event) => event.preventDefault());
        // The base media modal closes on mouse pointerup. Controls and swipes stay open.
        this.addEventListener('pointerup', (event) => {
          if (event.target.closest('.product-media-modal__content, .amk-viewer-controls')) event.stopPropagation();
        }, true);
        this.content.addEventListener('pointerdown', (event) => {
          this.swipeStart = {x: event.clientX, y: event.clientY, id: event.pointerId};
        });
        this.content.addEventListener('pointercancel', () => { this.swipeStart = null; });
        this.content.addEventListener('pointerup', (event) => this.onSwipe(event));
        // Handle the gesture before stopping the inherited close listener during capture.
        this.addEventListener('pointerup', (event) => {
          if (event.target.closest('.product-media-modal__content')) this.onSwipe(event);
        }, true);
        this.addEventListener('keydown', (event) => {
          if (event.key === 'Tab') {
            const focusable = Array.from(this.querySelectorAll('button, [href], [tabindex="0"]'))
              .filter((item) => !item.disabled && item.getClientRects().length);
            const first = focusable[0];
            const last = focusable[focusable.length - 1];
            // Recompute boundaries when a navigation button becomes disabled.
            event.stopPropagation();
            if (event.shiftKey && (document.activeElement === first || !this.contains(document.activeElement))) {
              event.preventDefault(); last?.focus();
            } else if (!event.shiftKey && (document.activeElement === last || !this.contains(document.activeElement))) {
              event.preventDefault(); first?.focus();
            }
            return;
          }
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          const rtl = getComputedStyle(this).direction === 'rtl';
          this.move((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
        });
      }

      get items() {
        return Array.from(this.content.querySelectorAll(':scope > [data-media-id]'));
      }

      onSwipe(event) {
        const start = this.swipeStart;
        this.swipeStart = null;
        if (!start || start.id !== event.pointerId) return;
        const dx = event.clientX - start.x;
        const dy = event.clientY - start.y;
        if (Math.abs(dx) < 48 || Math.abs(dx) <= Math.abs(dy) * 1.2) return;
        const rtl = getComputedStyle(this).direction === 'rtl';
        this.move((dx < 0 ? 1 : -1) * (rtl ? -1 : 1));
      }

      move(step) {
        const items = this.items;
        const index = items.findIndex((item) => item.classList.contains('active'));
        const nextIndex = index + step;
        if (nextIndex < 0 || nextIndex >= items.length) return;
        window.pauseAllMedia();
        this.activate(items[nextIndex]);
      }

      activate(activeMedia) {
        const items = this.items;
        if (!activeMedia) return;
        items.forEach((item) => {
          const active = item === activeMedia;
          item.classList.toggle('active', active);
          item.setAttribute('aria-hidden', String(!active));
        });
        const index = items.indexOf(activeMedia);
        this.previous.disabled = index === 0;
        this.next.disabled = index === items.length - 1;
        if (document.activeElement === this.previous && this.previous.disabled) this.next.focus({preventScroll: true});
        else if (document.activeElement === this.next && this.next.disabled) this.previous.focus({preventScroll: true});
        this.querySelector('[data-amk-viewer-count]').textContent = `${index + 1} / ${items.length}`;
        this.content.scrollTop = 0;
        this.content.scrollLeft = 0;
        if (activeMedia.nodeName === 'DEFERRED-MEDIA') activeMedia.loadContent();
      }

      hide() {
        const position = this.pagePosition;
        super.hide();
        if (this.classList.contains('amk-media-viewer') && position) {
          window.scrollTo({left: position.x, top: position.y, behavior: 'instant'});
          this.swipeStart = null;
        }
      }

      show(opener) {
        this.pagePosition = {x: window.scrollX, y: window.scrollY};
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        if (this.classList.contains('amk-media-viewer')) {
          this.activate(activeMedia || this.items[0]);
          return;
        }
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`)
          .forEach((element) => element.classList.remove('active'));
        if (!activeMedia) return;
        const template = activeMedia.querySelector('template');
        const content = template ? template.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();
        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
        if (activeMedia.nodeName === 'DEFERRED-MEDIA' && content && content.querySelector('.js-youtube')) activeMedia.loadContent();
      }
    }
  );
}
